// Household Management APIs
/**
 * @function ApiClient#GetHouseHold
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetHouseHold(cid, { building, doorPlate, floor }, options = {}) {
  return await this._get(`/community/${cid}/household?b=${building}&d=${doorPlate}&f=${floor}`, options);
}

/**
 * @function ApiClient#UpdateHouseHoldRentStatus
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} isRent
 * @param {any} options = {}
 */
export async function UpdateHouseHoldRentStatus(cid, { building, doorPlate, floor }, isRent, options = {}) {
  return await this._put(`/community/${cid}/household/rent?b=${building}&d=${doorPlate}&f=${floor}&s=${isRent ? "1" : "0"}`, null, options);
}

/**
 * @function ApiClient#GetHouseHoldListHasDeviceDBID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} dbid
 * @param {any} options = {}
 */
export async function GetHouseHoldListHasDeviceDBID(cid, dbid, options = {}) {
  return await this._get(`/community/${cid}/household_list?did=${dbid}`, options);
}

/**
 * @function ApiClient#GetHouseHoldListHasCard
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cardID
 * @param {any} options = {}
 */
export async function GetHouseHoldListHasCard(cid, cardID, options = {}) {
  return await this._get(`/community/${cid}/household_list?c=${cardID}`, options);
}

// Household Detail APIs
/**
 * @function ApiClient#GetHouseHoldDetailList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetHouseHoldDetailList(cid, { building, doorPlate, floor }, options = {}) {
  return await this._get(`/community/${cid}/household/detail_list?b=${building}&d=${doorPlate}&f=${floor}`, options);
}

/**
 * @function ApiClient#AddHouseHoldDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} detailObj
 * @param {any} options = {}
 */
export async function AddHouseHoldDetail(cid, detailObj, options = {}) {
  return await this._post(`/community/${cid}/household/detail`, detailObj, options);
}

/**
 * @function ApiClient#UpdateHouseHoldDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} detailObj
 * @param {any} options = {}
 */
export async function UpdateHouseHoldDetail(cid, detailObj, options = {}) {
  return await this._put(`/community/${cid}/household/detail`, detailObj, options);
}

/**
 * @function ApiClient#DeleteHouseHoldDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} options = {}
 */
export async function DeleteHouseHoldDetail(cid, did, options = {}) {
  return await this._delete(`/community/${cid}/household/detail/${did}`, options);
}

/**
 * @function ApiClient#GetHouseHoldDetailXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetHouseHoldDetailXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/household/detail_export`;
}

// Household Certificate APIs
/**
 * @function ApiClient#GetHouseholdCertificateList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetHouseholdCertificateList(cid, options = {}) {
  return await this._get(`/community/${cid}/household_certificate_list`, options);
}

/**
 * @function ApiClient#UpdateHouseholdCertificate
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} householdCertificateData
 * @param {any} images
 * @param {any} options = {}
 */
export async function UpdateHouseholdCertificate(cid, householdCertificateData, images, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(householdCertificateData));
  if (images) {
    images.forEach((img) => {
      formData.append("Image", img);
    });
  }
  return await this._put(`/community/${cid}/household_certificate`, formData, options);
}

/**
 * @function ApiClient#ImportHouseholdCertificateList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} xlsxFile
 * @param {any} options = {}
 */
export async function ImportHouseholdCertificateList(cid, xlsxFile, options = {}) {
  const formData = new FormData();
  formData.set("Xlsx", xlsxFile);
  return await this._post(`/community/${cid}/household_certificate/import`, formData, options);
}

// Household Rent APIs
/**
 * @function ApiClient#GetHouseholdRentDataList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetHouseholdRentDataList(cid, options = {}) {
  return await this._get(`/community/${cid}/household_rent_data_list`, options);
}

/**
 * @function ApiClient#HouseHoldRentMoveIn
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} rentData
 * @param {any} options = {}
 */
export async function HouseHoldRentMoveIn(cid, rentData, options = {}) {
  return await this._post(`/community/${cid}/household_rent_move_in`, rentData, options);
}

/**
 * @function ApiClient#UpdateHouseHoldRentData
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} rentData
 * @param {any} options = {}
 */
export async function UpdateHouseHoldRentData(cid, rentData, options = {}) {
  return await this._put(`/community/${cid}/household_rent_data`, rentData, options);
}

/**
 * @function ApiClient#HouseHoldRentMoveOut
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} date
 * @param {any} options = {}
 */
export async function HouseHoldRentMoveOut(cid, { building, doorPlate, floor }, date, options = {}) {
  return await this._post(`/community/${cid}/household_rent_move_out?b=${building}&d=${doorPlate}&f=${floor}&od=${date}`, null, options);
}

/**
 * @function ApiClient#GetHouseholdRentHistoryList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetHouseholdRentHistoryList(cid, { building, doorPlate, floor }, options = {}) {
  return await this._get(`/community/${cid}/household_rent_history_list?b=${building}&d=${doorPlate}&f=${floor}`, options);
}
